import styled from '@mui/system/styled';
import TabList from '@mui/lab/TabList'
import Tab from "@mui/material/Tab"
export const CustomeSuperTab = styled(TabList)(({ theme, locale }) => ({
    '& .MuiTabs-flexContainer': {
        justifyContent: "stretch",
        gap: "0rem"
    },
    '@media (min-width:768px) and (max-width:912px)': {

        '& .MuiTabs-flexContainer': {
            justifyContent: "space-evenly",
            // gap: "3rem"
        },
    },
    '@media (min-width:913px) ': {

        '& .MuiTabs-flexContainer': {
            justifyContent: "space-between",

        },
    },
 }))
export const CustomeTab = styled(Tab)(({ theme, locale }) => ({
    color: "black",
    minWidth: 0,
    '&.Mui-selected': {
        border: "0.5px solid #ccf0ef",
        color: "#008C8D  !important",
        fontWeight: 600,
        borderRadius: "12px ",
        opacity: "1 !important",
        backgroundColor: "white !important",
    },
    '& .MuiTabs-indicator': {

        backgroundColor: "white",
        height: "0"

    },
    '& .MuiTabs-flexContainer': {
        justifyContent: "stretch",
        gap: "0rem"
    },


    opacity: 0.5,
    '@media (min-width:301px) and (max-width:767px)': {
        fontSize: "0.9rem ",
        width: "50%",
    },



    '@media (min-width:280px) and (max-width:300px)': {


        fontSize: "0.7rem",
        width: "50% !important",
        minWidth: 0,

    }
    ,
    '@media (min-width:768px) and (max-width:912px)': {

        '& .MuiTabs-flexContainer': {
            justifyContent: "space-evenly",
            // gap: "3rem"
        },

        fontSize: "1rem",
        width: "50%",
    },
    '@media (min-width:913px) ': {
        '& .MuiTabs-flexContainer': {
            justifyContent: "space-between",
        },
        fontSize: "1.2rem",
        width: "50%",
        opacity: 0.5,
        height: "60px",
    },

}))